import axios from 'axios';
import querystring from 'querystring';
import moment from 'moment';
import CONSTANTS from './constants';
import { preparaParaBusca, getIntervaloFichas } from './utils/utils';

export const fazBusca = async () => {
    const url = `${CONSTANTS.API.busca}`;
    let args = {
        'per_page': -1,
    };

    const queryString = querystring.stringify(args);

    // console.log({queryString, filters});
    try {
        const { data } = await axios.get(`${url}?${queryString}`);
        const fichas = {};
        for (let tipo of Object.keys(data)) {
            fichas[tipo] = data[tipo].map((ficha) => {
                const fichaTax = {...ficha.tax};
                for (let tax of CONSTANTS.TAXONOMIAS_FILTROS) {
                    if (tax.hasOwnProperty('relatedTaxes')) {
                        let merged = [];
                        for (let relatedTaxId of tax.relatedTaxes) {
                            if (ficha.tax.hasOwnProperty(relatedTaxId)) {
                                merged.push(ficha.tax[relatedTaxId][0]);
                            }
                        }
                        fichaTax[tax.id] = merged;
                        continue;
                    }
                }
                return {...ficha, tax: fichaTax};
            });
        }
        // console.log({resultado: fichas});
        return fichas;
    } catch (error) {
        alert(error);
        alert(url);
        console.log(error);
    }
};

export const filtraFichas = (filters, fichas, opcoes, isMobile) => {
    // console.log({filters, fichas});
    const fichasVisiveis = {};
    let qtdeFichasVisiveis = 0;
    let nFamiliasAmeacadas = 0;
    let nFamiliasRemovidas = 0;
    let nFamiliasSuspensaoDefinitiva = 0;

    const q = (filters.hasOwnProperty('q') && filters.q !== '')
        ? preparaParaBusca(filters.q)
        : null;

    for (let tipo of filters.tipoGroup) {
        if (tipo.active && fichas.hasOwnProperty(tipo.id)) {
            fichasVisiveis[tipo.id] = []
            for (let i = 0; i < fichas[tipo.id].length; i++) {
                const ficha = fichas[tipo.id][i];
                let passedFilter = true;
                for (let tax of CONSTANTS.TAXONOMIAS_FILTROS) {
                    if (filters.hasOwnProperty(tax.slug) && filters[tax.slug].length > 0) {
                        passedFilter = false;
                        for (let taxFilter of filters[tax.slug]) {
                            if (ficha.tax.hasOwnProperty(tax.slug) && (ficha.tax[tax.slug].includes(taxFilter.slug))) {
                                passedFilter = true;
                                break;
                            }
                        }

                        if (!passedFilter) {
                            break;
                        }
                    }
                }

                if (!passedFilter) {
                    continue;
                }
                if (!q) {
                    fichasVisiveis[tipo.id].push(ficha);
                    continue;
                }

                passedFilter = false;

                for (let field of tipo.searchFields) {
                    const alvo = preparaParaBusca(ficha[field]);
                    if (alvo.includes(q)) {
                        passedFilter = true;
                        break;
                    }
                }
                if (passedFilter) {
                    fichasVisiveis[tipo.id].push(ficha);
                    continue;
                }

                for (let field of tipo.searchMetaFields) {
                    const alvo = preparaParaBusca(ficha.meta[field]);
                    if (alvo.includes(q)) {
                        passedFilter = true;
                        break;
                    }
                }
                if (passedFilter) {
                    fichasVisiveis[tipo.id].push(ficha);
                    continue;
                }

                for (let tax of CONSTANTS.TAXONOMIAS_FILTROS) {
                    if (ficha.tax.hasOwnProperty(tax.slug) && ficha.tax[tax.slug].length > 0) {
                        for (let alvo of ficha.tax[tax.slug]) {
                            if (alvo.includes(q)) {
                                passedFilter = true;
                                break;
                            }
                        }
                    }
                    if (passedFilter) {
                        break;
                    }
                }
                if (passedFilter) {
                    fichasVisiveis[tipo.id].push(ficha);
                }
            }
            qtdeFichasVisiveis += fichasVisiveis[tipo.id].length;

            for( let i = 0; i  < fichasVisiveis[tipo.id].length; i++ ){
              if( fichasVisiveis[tipo.id][i].meta['numero_de_familias_ameacadas'] ){
                nFamiliasAmeacadas += Number(fichasVisiveis[tipo.id][i].meta['numero_de_familias_ameacadas']);
              }
              if( fichasVisiveis[tipo.id][i].meta['numero_de_familias_despejadas'] ){
                nFamiliasRemovidas += Number(fichasVisiveis[tipo.id][i].meta['numero_de_familias_despejadas']);
              }
              if( fichasVisiveis[tipo.id][i].meta['numero_de_familias_suspensao_definitiva'] ){
                nFamiliasSuspensaoDefinitiva += Number(fichasVisiveis[tipo.id][i].meta['numero_de_familias_suspensao_definitiva']);
              }
            }
        }
    }
    const intervaloData = getIntervaloFichas(fichasVisiveis, isMobile);
    return {fichasVisiveis, qtdeFichasVisiveis, nFamiliasAmeacadas, nFamiliasRemovidas, nFamiliasSuspensaoDefinitiva, intervaloData, opcoesVisiveis: opcoes};
};

export const filtraIntervaloData = (newValue, fichasVisiveis) => {
    let newFichasVisiveis = {};
    let newQtdeFichasVisiveis = 0;
    for (let tipo of Object.keys(fichasVisiveis)) {
        newFichasVisiveis[tipo] = [];
        for (let i = 0; i < fichasVisiveis[tipo].length; i++) {
            const date = moment(fichasVisiveis[tipo][i].post_date).valueOf();
            if (date >= newValue[0] && date <= newValue[1]) {
                newFichasVisiveis[tipo].push(fichasVisiveis[tipo][i]);
                newQtdeFichasVisiveis++;
            }
        }
    }
    return {fichasVisiveis: newFichasVisiveis, qtdeFichasVisiveis: newQtdeFichasVisiveis};
};

export const resgataTaxonomia = async (taxonomia) => {
    try {
        const { data } = await axios.get(`${CONSTANTS.API.taxonomia}/${taxonomia}`);
        // console.log(data);
        return data;
    } catch (error) {
        alert(error);
    }
};

export const resgataOpcoes = async () => {
    try {
        const { data } = await axios.get(`${CONSTANTS.API.taxonomias}`);
        let opcoes = {...data};
        for (let tax of CONSTANTS.TAXONOMIAS_FILTROS) {
            if (tax.hasOwnProperty('relatedTaxes')) {
                let merged = [];
                for (let relatedTaxId of tax.relatedTaxes) {
                    merged = merged.concat(data[relatedTaxId].map((item) => {
                        return {...item, tax: relatedTaxId};
                    }));
                }
                opcoes[tax.id] = merged;
                continue;
            }
        }
        return opcoes;
    } catch (error) {
        console.log(error);
    }
};

export const getImgUrl = async (id) => {
    try {
        const {
            data: { link },
    } = await axios.get(`${CONSTANTS.API.media}/${id}`);
        return link;
    } catch (error) {
        console.log(error);
    }
};

export const getPopupFichaContent = async (ficha) => {
    const popupFichaContentCacheJSON = localStorage.getItem('popupFichaContentCache');
    const popupFichaContentCache = (popupFichaContentCacheJSON)
        ? JSON.parse(popupFichaContentCacheJSON)
        : {};

    if (
        popupFichaContentCache.hasOwnProperty(ficha.ID) &&
        popupFichaContentCache.hasOwnProperty(ficha.ID).post_modified !== ficha.post_modified
    ) {
        return popupFichaContentCache[ficha.ID];
    }

    try {
        const res = await axios.get(`${CONSTANTS.API.sidebarMeta}?post_id=${ficha.ID}`);
        let imgUrl = null;
        if (ficha.meta.logo_id || ficha.meta._thumbnail_id) {
            imgUrl = await getImgUrl((ficha.meta._thumbnail_id) ? ficha.meta._thumbnail_id : ficha.meta.logo_id);
        }
        const thisPopupFichaContent = {
            metaHTML: res.data,
            imgUrl: imgUrl,
            post_modified: ficha.post_modified
        };

        popupFichaContentCache[ficha.ID] = thisPopupFichaContent;
        localStorage.setItem('popupFichaContentCache', JSON.stringify(popupFichaContentCache));

        return thisPopupFichaContent;
    } catch (error) {
        console.log(error);
        return {
            metaHTML: '',
            imgUrl: null
        };
    }
};

export const getFeaturedImage = async (id) => {
    try {
        const res = await axios.get(`${CONSTANTS.MEDIA_API_URL}/${id}`);
        return res.data.guid.rendered;
    } catch (error) {
        console.log(error);
        return '';
    }
};
